import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import ApiService from './api';

export interface StatusResponse {
  page: {
    id: string;
    name: string;
    url: string;
    time_zone: string;
    updated_at: string;
  };
  status: {
    indicator: 'none' | 'minor' | 'major' | 'critical';
    description: string;
  };
}

const SYSTEM_STATUS_ENDPOINT = 'https://status.customerio.com/api/v2/status.json';

export default class SystemStatusService extends Service {
  @service api!: ApiService;

  fetchSystemStatus = task({ drop: true }, async () => {
    try {
      let res = await fetch(SYSTEM_STATUS_ENDPOINT, {
        method: 'GET',
        redirect: 'follow',
      });
      return await res.json();
    } catch (e) {
      return e.message;
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'system-status': SystemStatusService;
  }
}
